// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2qwbC","colMaxWidth":"Table_colMaxWidth__d1aNK"};